import Api from '@Api/index';
import { getClientFromCurrentUrl } from '@Utils/functions';
import { useQuery } from '@tanstack/react-query';

const clientId = getClientFromCurrentUrl();
export default function useGetClientConfigs() {
	return useQuery({
		queryKey: ['clientSettings'],
		queryFn: () => Api.Clients.getClientSettings(clientId),
	});
}
